import clsx from 'clsx';
import type { GroupBase, OptionProps } from 'react-select';
import type { SelectorOption } from '../../types';
import { optionWrapperStyles } from './styles';
import { AgentAvatar } from './AgentAvatar';

interface SelectorOptionProps<Value extends string | number>
  extends OptionProps<SelectorOption<Value>, false, GroupBase<SelectorOption<Value>>> {
  intent: 'default' | 'old';
}

export const OptionWithImage = <Value extends string | number>(props: SelectorOptionProps<Value>) => {
  const { data, intent, innerProps, isSelected } = props;
  const { value, label, image } = data;
  const showAvatar = value !== '' && value !== null;

  return (
    <div {...innerProps} className={clsx(optionWrapperStyles({ intent, isSelected }))}>
      <div className="flex items-center gap-2">
        {showAvatar && <AgentAvatar label={label} image={image} size={32} />}
        <p className="text-body-responsive text-black">{label}</p>
      </div>
    </div>
  );
};
